import gql from "graphql-tag";

export const GetProfileRoles = gql`
  query GetProfileRoles($ProfileId: ID!) {
    GetProfileRoles(ProfileId: $ProfileId) {
      Active
      Description
      Id
      CreatedAt
      UpdatedAt
      RoleName
    }
  }
`;
